/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { RootState, SelectedDocumentDraftState } from 'src/store/types';

export const getSelectedDocumentDraft = (
  state: RootState,
): SelectedDocumentDraftState => state.selectedDocumentDraft;
